import React, { FC } from 'react';
import { Cart, Montant, MontantOption, Remise } from './iCart';
import { TranslationProps, WithTranslation } from "../../contexts/TranslationContext";
import { getShopInfosInStorage } from './ShopInfos';
import { formatPrice } from '../mon-compte/MonCompteAction';
import RenderSelectOrderDelayType from './RenderSelectOrderDelayType';

interface MontantsAppProps extends TranslationProps {
  cart: Cart;
  montants: Montant;
  montantsOptions: MontantOption;
  remises: Remise[];
  montants_transport: number;
  francoAtteint?: boolean;
  isModeHT: boolean;
  enabledFeatureOrderDelayType?: boolean;
}

const RenderMontantsCart: FC<MontantsAppProps> = (props): JSX.Element => {

  const montantRemise = (): string => {
    let montant : number = 0;
    for (const remise of props.remises) {
      montant += remise.montant;
    }

    return `${formatPrice(montant.toFixed(2))} €`;
  };

  const montantLivraison = (): string => {
    let montantLiv = 0;
    const shopInfos = getShopInfosInStorage();
    const isNotDeixo = !window.location.hostname.includes('deixo');

    if (props.montants_transport) {
      const montantTransport = JSON.parse(localStorage.getItem('excludedTax') ?? 'true') ? props.montants_transport : props.montants_transport * (1 + (props.montants.taux_tva / 100))
      montantLiv = montantTransport;
    } else if ((shopInfos.Ref === 'MT' || shopInfos.Ref === 'DT') && isNotDeixo && props.francoAtteint) {
      montantLiv = 0;
    }
    return `${formatPrice(montantLiv.toFixed(2))} €`;
  };

  const getTVA = (): string => {
    return `${props.montants.taux_tva ?? 20}%`;
  };

  const getHtSansRemise = () => {
    return `${formatPrice(props.montants?.ht_sans_remise?.toFixed(2) ?? '0.00')}`;
  }
  const getHt = () => {
    return `${formatPrice(props.montants?.ht?.toFixed(2) ?? '0.00')}`;
  }

  const classRemise = (): string => {
    let classRemise = 'd-none';
    if (montantRemise() !== `${formatPrice('0.00')} €` && montantRemise() !== `${formatPrice('0.00')} €`) {
      classRemise = 'd-flex';
    }
    return classRemise;
  };

  const getLinkDeliveryMoreInfos = (): string => {
    const shopInfos = getShopInfosInStorage();
    const linksByShop: Record<string, string> = {
      MT: '/aide/q-quels-sont-les-differents-modes-de-livraison/14',
      TE: '/aide/q-quels-sont-les-differents-modes-de-livraison/47',
      TO: '/aide/q-quels-modes-de-livraison-proposez-vous/82',
      DT: '/help/q-quels-sont-les-modes-de-livraison/209',
      ME: '/aide/q-quels-modes-de-livraison-proposez-vous/167'
    }
    return linksByShop?.[shopInfos?.Ref] ?? '';
  };
  const linkDeliveryMoreInfos = getLinkDeliveryMoreInfos();

  return (
    <div id="montantPanier" className="d-flex flex-column font14 col-lg-4 col-md-12 col-12 p-2 p-lg-0 mt-md-3 mt-lg-0">
      {(props.enabledFeatureOrderDelayType && props.cart.order_delay_type_id) && (
        <div className="d-flex display-flex flex-wrap justify-content-between align-items-center mr-lg-4 mb-2">
          <p className='mb-0 pb-0'>{props.textsContent?.['CART_MAX_DELIVERY']}</p>
          <RenderSelectOrderDelayType cart={props.cart} excludedPort />
        </div>
      )}
      <div className="d-flex mr-lg-4">
        <p className="flex-grow-1">{props.textsContent?.['CART_AMOUNT_DELIVERY']} {props.isModeHT ? props.textsContent?.['SWITCH_TEXT_HT'] : props.textsContent?.['SWITCH_TEXT_TTC']}</p>
        {props.montants_transport > 0 && (<span id="livraisonHT">{montantLivraison()}</span>)}
        {props.montants_transport <= 0 && (
          <div className="font10">{props.textsContent?.['CART_DELIVERY_SMALL_EXPLANATION']}
            {linkDeliveryMoreInfos && linkDeliveryMoreInfos !== '' && (
              <a href={linkDeliveryMoreInfos}> {props.textsContent?.['CART_DELIVERY_SMALL_EXPLANATION_MORE_INFOS']}</a>
            )}
          </div>
        )}
      </div>
      <div className="big font-weight-bold d-flex mr-lg-4">
        <p className="letter-spacing-condensed font18 flex-grow-1">{props.textsContent?.['CART_AMOUNT_TOTAL_TTC']}</p>
        <span id="montantTTC" className="font18">
          {`${formatPrice(props.montants.ttc.toFixed(2))} €`}
        </span>
      </div>
      <div style= {{ borderTop: '1px solid grey', margin: '10px 10px 10px 0' }}></div>
      <div className="d-flex mr-lg-4" style={{ color: 'grey' }}>
        <p className="flex-grow-1  text-uppercase">{props.textsContent?.['CART_AMOUNT_TOTAL_HT']}</p>
        <span id="montantHT">{getHtSansRemise()} €</span>
      </div>
      
      <div className={classRemise() + ' mr-lg-4'} >
        {props.remises.map(element => (
          <div className="w-100 d-flex" key={element.description}>
            <p className='flex-grow-1'>{props.textsContent?.['CART_AMOUNT_REMISE']} ({element.description})</p>
            <span className="text-right">-{element.montant.toFixed(2).replace('.', ',').concat(' €')}</span>
          </div>
        ))}
      </div>
      
      {props.remises.length > 0 && props.montants?.ht_sans_remise > props.montants?.ht  && 
        <div className="d-flex mr-lg-4" style={{ color: 'grey' }}>
        <p className="flex-grow-1 text-uppercase">{props.textsContent?.['CART_AMOUNT_TOTAL_HT_WITH_DISCOUNT']}</p>
        <span id="montantHT">{getHt()} €</span>
        </div>
         }
      <div className="d-flex mr-lg-4" style={{ color: 'grey' }}>
          <p className="flex-grow-1">{getTVA()} {props.textsContent?.['CART_AMOUNT_TVA']}</p>
        <span id="tva">
          {`${formatPrice(props.montants.tva.toFixed(2))} €`}
        </span>
      </div>
    </div>
  );
};

export default WithTranslation<MontantsAppProps>(RenderMontantsCart, 'CART_TUNNEL', 'SWITCH_TAXES_PRICES');
